import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-service-state-schedule-interval',
    templateUrl: './service-state-schedule-interval.component.html',
    styleUrls: ['./service-state-schedule-interval.component.scss'],
})
export class ServiceStateScheduleIntervalComponent implements OnDestroy {
    destroy$ = new Subject();

    @Input() timeForm: FormGroup;

    @Input() closeable = false;

    @Output() cancelCreate = new EventEmitter();
    @Output() toTimeChanged = new EventEmitter<void>();

    get fromTime(): AbstractControl {
        return this.timeForm.get('from');
    }

    get toTime(): AbstractControl {
        return this.timeForm.get('to');
    }

    cancelCreateAction(): void {
        this.cancelCreate.emit();
    }

    onToTimeChange(): void {
        this.toTimeChanged.emit();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
